import LZString from 'lz-string';

export const getItem = (name, decompress = false) => {
  try {
    let serializedItem = sessionStorage.getItem(name);
    if (serializedItem === null) return undefined;

    if (decompress === true) serializedItem = LZString.decompressFromUTF16(serializedItem);

    return JSON.parse(serializedItem);
  } catch (err) {
    console.error('getItem', err);
    return undefined;
  }
};

export const removeItem = (name) => {
  try {
    if (sessionStorage.getItem(name)) sessionStorage.removeItem(name);
  } catch (err) {
    console.error('removeItem', err);
  }
};

export const setItem = (name, value, compress = false) => {
  try {
    let serializedItem = JSON.stringify(value);
    if (compress === true) serializedItem = LZString.compressToUTF16(serializedItem);
    sessionStorage.setItem(name, serializedItem);
  } catch (err) {
    console.error('setItem', err);
  }
};

export const key = (index) => {
  return sessionStorage.key(index);
};

export const getLength = () => {
  return sessionStorage.length;
};

export const sessionSet = (key, data) => {
  sessionStorage.setItem(key, JSON.stringify(data));
};

export const sessionGet = (key) => {
  const data = sessionStorage.getItem(key);
  try {
    return JSON.parse(data);
  } catch (error) {
    console.error('sessionGet', error);
  }
};

export default {
  getItem,
  setItem,
  removeItem,
  key,
  get length() {
    return getLength();
  },
};
